import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";

const Button = styled.div`
	padding: 0 16px;
	display: flex;
	transition: all 0.3s ease;
	cursor: pointer;
	height: 32px;
	border-radius: 6px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${MAIN_THEME.DARK_BG_TERTIARY};
	border: 1px solid ${MAIN_THEME.BORDER_COLOR};
	color: ${MAIN_THEME.TEXT_PRIMARY};
	font-size: 14px;
	font-weight: 500;

	&:hover {
		border-color: ${MAIN_THEME.SECONDARY};
		box-shadow: 0 0 10px rgba(0, 217, 255, 0.2);
	}

	@media (max-width: 768px) {
		padding: 0 12px;
		font-size: 13px;
	}
`;

const Container = styled.div`
	position: relative;
`;

interface Props {
	onClick: () => void;
}

const ClearFiltersButton = (props: Props): JSX.Element => {
	const { onClick } = props;

	return (
		<Container>
			<Button onClick={onClick}>Clear</Button>
		</Container>
	);
};

export default ClearFiltersButton;
